import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex relative" }
const _hoisted_2 = {
  key: 2,
  class: "absolute flex top-0 left-0 w-full h-full bg-brand-black z-50"
}
const _hoisted_3 = { class: "bg-brand-black flex w-full p-4 py-5 font-medium text-xl text-white border-b-4 border-brand-dark-gray max-h-80 overflow-scroll" }
const _hoisted_4 = { class: "text-sm text-white p-3" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "flex flex-col p-4 space-y-2" }
const _hoisted_7 = { class: "flex grid gap-2 grid-cols-3" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "animate-spin h-7 w-7 text-white m-auto",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_10 = {
  key: 1,
  class: "m-auto",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col p-4 space-y-2"
}
const _hoisted_12 = { class: "flex flex-col space-y-2" }

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTextarea,
  IonToolbar,
  modalController,
  toastController,
  useIonRouter,
} from '@ionic/vue';
import {computed, onMounted, PropType, Ref, ref} from 'vue';
import InputCheckbox from "@/components/InputCheckbox.vue";
import {PostPrivacy} from "@/definitions/PostPrivacy";
import useCamera from "@/composables/useCamera";
import {CameraResultType, CameraSource} from "@capacitor/camera";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {FeedPostInterface} from "@/interfaces/FeedPostInterface";
import {UserInterface} from "@/interfaces/UserInterface";
import {usePremium} from "@/composables/usePremium";
import {Mentionable} from 'vue-mention'
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {useAppSettings} from "@/composables/useAppSettings";


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedNewPostPage',
  props: {
  post: {
    type: Object as PropType<FeedPostInterface>,
    required: false
  },
  authUser: {
    type: Object as PropType<UserInterface>,
    required: true
  }
},
  setup(__props) {

const props = __props


const loading = ref(true)
const busy = ref(false)
const posting = ref(false)


const privacyOptions: Ref<any[]> = ref([])

const postContent = ref('')
const postPrivacy: Ref<PostPrivacy[]> = ref([])
const postPhotos: Ref<string[]> = ref([])

onMounted(async () => {

  await reset()

  const enableNsfw = useAppSettings().settings.value.enableNsfw !== false
  if (enableNsfw) {
    privacyOptions.value.push({
      text: 'NSFW',
      description: 'Not Safe For Work 😈🍆💦',
      value: PostPrivacy.XRated,
    })
  }

  privacyOptions.value.push(
      {
        text: 'Inner Circle',
        description: 'Anything goes! Only visible to your friends.',
        value: PostPrivacy.InnerCircle
      },
      {
        text: 'Public',
        description: 'All posts will be manually verified before appearing on the public feed. Nudity of any kind is not accepted here.',
        value: PostPrivacy.Public
      }
  )

  if (props.post) {
    postContent.value = props.post.data.original_content
    postPrivacy.value = [props.post.visibility as PostPrivacy]
    postPhotos.value = props.post.media.map((m) => {
      return m.url
    })
  }

  loading.value = false
})

const reset = async () => {
  postContent.value = '',
      postPrivacy.value = []
  postPhotos.value = []
  posting.value = false
  busy.value = false
}

const goBack = async () => {

  if (busy.value || posting.value) return

  const modal = await alertController.create({
    header: 'Discard Post',
    message: 'Are you sure you want to discard this post?',
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: () => {
          modalController.dismiss()
          reset()
        }
      },
      {
        text: 'No',
      },

    ]
  })

  await modal.present()

}

const addPhoto = async () => {

  if (busy.value || posting.value) return

  try {
    const photo = await useCamera(CameraSource.Photos, CameraResultType.Base64)
    busy.value = true
    if (Object.prototype.hasOwnProperty.call(photo, 'base64String')) postPhotos.value.push(`data:image/${photo.format};base64,${photo.base64String}`)
    busy.value = false
  } catch (e) {
    busy.value = false
  }

}

const removePhoto = async (index: number) => {

  if (busy.value || posting.value) return

  const modal = await alertController.create({
    header: 'Remove Photo',
    message: 'Are you sure you want to remove this photo from the post?',
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: async () => {
          postPhotos.value.splice(index, 1)
        }
      },
      {
        text: 'No',
      },

    ]
  })

  await modal.present()

}

const canPost = computed(() => {
  return (postContent.value.length > 3 || postPhotos.value.length > 0) && postPrivacy.value.length > 0
})

const postToFeed = async () => {

  if (!canPost.value) return

  try {
    posting.value = true
    const newPost = await ApiService.Feed().post(postContent.value, postPrivacy.value[0])
    if (postPhotos.value.length) await ApiService.Feed().attachMedia(newPost.id, postPhotos.value)
    await reset()
    Observable.emit(ObservableEvent.FeedScrollTop)
    await modalController.dismiss()
  } catch (e: any) {

    posting.value = false
    if (e.status === 429) {
      return usePremium().presentPayWall({
        text: e.data.message,
        callback: () => {
          //
        }
      });
    }

    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }
}

const updatePost = async () => {

  if (!canPost.value) return
  if (!props.post) return
  try {
    posting.value = true
    const updatedPost = await ApiService.Feed().updatePost(props.post.id, postContent.value, postPrivacy.value[0])
    await ApiService.Feed().attachMedia(props.post.id, postPhotos.value)
    await reset()
    await modalController.dismiss()
    Observable.emit(ObservableEvent.FeedPostChanged, updatedPost)
    posting.value = false
  } catch (e: any) {
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
    posting.value = false
  }
}

const loadingUsers = ref(false)
const mentionableUsers: Ref<any[]> = ref([])

const mentionableUserId = (name: string) => {
  return (mentionableUsers.value.find((user: UserBasicInformationInterface) => {
    return user.name === name
  })).id
}

const loadUsers = async (searchText = '') => {
  loadingUsers.value = true
  mentionableUsers.value = await fetchUsers(searchText)
  loadingUsers.value = false
}

const fetchUsers = async (search: string) => {
  const results = await ApiService.Search().users(search)
  return results.map((result: UserBasicInformationInterface) => {
    return {
      value: result.name,
      label: result.name
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { class: "!p-0 !m-0" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { class: "justify-between flex w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        class: "fill-current text-white w-6 h-6 p-0.5",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512"
                      }, [
                        _createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_1, [
                    (!__props.post)
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 0,
                          onClick: postToFeed,
                          class: "!text-xl"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({
                  'text-brand-light-gray' : !canPost.value,
                  'text-brand-lime' : canPost.value
                })
                            }, "Post ", 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (__props.post)
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 1,
                          onClick: updatePost,
                          class: "!text-xl"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({
                  'text-brand-light-gray' : !canPost.value,
                  'text-brand-lime' : canPost.value
                })
                            }, "Update ", 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (posting.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("svg", {
                            class: "animate-spin m-auto h-5 w-5 text-brand-lime",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Mentionable), {
              class: "w-full",
              keys: ['@'],
              items: mentionableUsers.value,
              offset: "6",
              onOpen: _cache[1] || (_cache[1] = ($event: any) => (loadUsers())),
              onSearch: _cache[2] || (_cache[2] = ($event: any) => (loadUsers($event))),
              "filtering-disabled": ""
            }, {
              "no-result": _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(loadingUsers.value ? 'Loading...' : 'No users found.'), 1)
              ]),
              "item-@": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_5, " @" + _toDisplayString(item.value), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(IonTextarea), {
                  "auto-grow": "",
                  autocapitalize: "on",
                  modelValue: postContent.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((postContent).value = $event)),
                  placeholder: "What's on your mind?"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Images", -1)),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postPhotos.value, (photo, pIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pIndex,
                  style: _normalizeStyle({
                'background-image' : `url('${photo}')`
              }),
                  class: "w-full h-28 bg-brand-dark-gray bg-cover bg-center rounded-2xl flex p-2"
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    onClick: ($event: any) => (removePhoto(pIndex)),
                    class: "mt-auto ml-auto",
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("rect", {
                      width: "25",
                      height: "25",
                      rx: "12.5",
                      fill: "white"
                    }, null, -1),
                    _createElementVNode("path", {
                      d: "M16.8921 7L12.5 11.3921L8.10786 7L7 8.10786L11.3921 12.5L7 16.8921L8.10786 18L12.5 13.6079L16.8921 18L18 16.8921L13.6079 12.5L18 8.10786L16.8921 7Z",
                      fill: "black"
                    }, null, -1)
                  ]))], 8, _hoisted_8))
                ], 4))
              }), 128)),
              _createElementVNode("div", {
                onClick: addPhoto,
                class: "w-full h-28 bg-brand-dark-gray rounded-2xl flex"
              }, [
                (busy.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (!busy.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("path", {
                        d: "M12.5301 5.5L12.5117 19.5",
                        stroke: "white",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1),
                      _createElementVNode("path", {
                        d: "M5.5 12.5H19.5",
                        stroke: "white",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Who can see this post?", -1)),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privacyOptions.value, (p, pIndex) => {
                    return (_openBlock(), _createBlock(InputCheckbox, {
                      key: pIndex,
                      name: "privacy",
                      "return-single-value": true,
                      modelValue: postPrivacy.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((postPrivacy).value = $event)),
                      option: p
                    }, null, 8, ["modelValue", "option"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})